module.exports = __webpack_public_path__ + "static/img/12.a8560552.png";